import moment from "moment";
import { useEffect, useState } from "react";
import { GET_ALL_BLOG_HISTORIES } from "../../Apollo/AdminServices/QueryRequest";
import graphHandler from "../../Apollo/graphHandler";
function useBlogHistory(id) {
  const [blogHistory, setScreenerHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (id) {
      getBlogHistory(id);
    } else {
      setScreenerHistory([]);
    }
  }, [id]);
  const getBlogHistory = async (blog_id) => {
    if (!blog_id) return;
    setLoading(true);
    try {
      const { data } = await graphHandler().invoke(
        GET_ALL_BLOG_HISTORIES,
        { blog_id },
        1,
        false,
        true
      );
      if (
        data &&
        data.getAllBlogHistories &&
        data.getAllBlogHistories.blog_history_list
      ) {
        // console.log(
        //   "getAllBlogHistories Success",
        //   data.getAllBlogHistories.blog_history_list
        // );
        setScreenerHistory(
          data.getAllBlogHistories.blog_history_list
            .slice()
            .sort(
              (a, b) =>
                new Date(b.updated_at ? b.updated_at : b.created_at) -
                new Date(a.updated_at ? a.updated_at : a.created_at)
            )
        );
        setLoading(false);
      } else {
        setScreenerHistory([]);
        setLoading(false);
      }
    } catch (error) {
      console.log("getAllBlogHistories Error", error);
      setScreenerHistory([]);
      setLoading(false);
    }
  };
  return {
    blogHistory,
    loading,
    getBlogHistory,
  };
}
export default useBlogHistory;
